export class CreateDlsgPolicyRequest {
    'name';
    'enabled';
    'resourceInclusion';
    'policyPlan';
    'scheduleMode';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "resourceInclusion",
            "baseName": "resourceInclusion",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "policyPlan",
            "baseName": "policyPlan",
            "type": "DlsgPolicyPlan",
            "format": ""
        },
        {
            "name": "scheduleMode",
            "baseName": "scheduleMode",
            "type": "ScheduleMode",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateDlsgPolicyRequest.attributeTypeMap;
    }
    constructor() {
    }
}
